import { useState, useEffect } from "react";
import { Grid, Card, CardContent, TextField, MenuItem } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate, useParams } from "react-router-dom";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function AdministratorForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const auth = getAuth();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "admin",
    status: "active",
    password: ""
  });

  useEffect(() => {
    if (id) {
      fetchAdministrator();
    }
  }, [id]);

  const fetchAdministrator = async () => {
    try {
      console.log("Buscando administrador con ID:", id);
      const userDoc = await getDoc(doc(db, "users", id));
      console.log("Documento encontrado:", userDoc.exists());
      if (userDoc.exists()) {
        const data = userDoc.data();
        console.log("Datos del documento:", data);
        setFormData({
          ...data,
          password: "" // No mostramos la contraseña por seguridad
        });
      }
    } catch (error) {
      console.error("Error detallado al obtener administrador:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Iniciando guardado de administrador");
      if (id) {
        console.log("Actualizando administrador existente");
        await setDoc(doc(db, "users", id), {
          name: formData.name,
          email: formData.email,
          role: formData.role,
          status: formData.status,
          updatedAt: new Date()
        }, { merge: true });
        console.log("Administrador actualizado exitosamente");
      } else {
        console.log("Creando nuevo administrador");
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          formData.email,
          formData.password
        );
        console.log("Usuario creado en Authentication:", userCredential.user.uid);

        await setDoc(doc(db, "users", userCredential.user.uid), {
          name: formData.name,
          email: formData.email,
          role: formData.role,
          status: formData.status,
          createdAt: new Date()
        });
        console.log("Datos guardados en Firestore");
      }
      navigate("/administrators");
    } catch (error) {
      console.error("Error detallado al guardar administrador:", error);
      alert("Error al guardar el administrador: " + error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {id ? "Editar Administrador" : "Nuevo Administrador"}
                </MDTypography>
              </MDBox>
              <CardContent>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Nombre"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    {!id && (
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Contraseña"
                          name="password"
                          type="password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        select
                        label="Rol"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        required
                      >
                        <MenuItem value="admin">Administrador</MenuItem>
                        <MenuItem value="supervisor">Supervisor</MenuItem>
                        <MenuItem value="user">Usuario</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        select
                        label="Estado"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        required
                      >
                        <MenuItem value="active">Activo</MenuItem>
                        <MenuItem value="inactive">Inactivo</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <MDBox display="flex" justifyContent="flex-end" gap={2}>
                        <MDButton
                          variant="outlined"
                          color="info"
                          onClick={() => navigate("/administrators")}
                        >
                          Cancelar
                        </MDButton>
                        <MDButton
                          type="submit"
                          variant="gradient"
                          color="info"
                        >
                          {id ? "Actualizar" : "Crear"}
                        </MDButton>
                      </MDBox>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AdministratorForm; 